module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container",
    attrs: {
      "id": "nav"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.navs), function(nav, index) {
    return _c('div', {
      directives: [{
        name: "first",
        rawName: "v-first.once",
        value: (index),
        expression: "index",
        modifiers: {
          "once": true
        }
      }],
      staticClass: "swiper-slide nav-item",
      on: {
        "click": function($event) {
          _vm.goToRecommend(nav)
        }
      }
    }, [_c('div', {
      staticClass: "nav-item-head"
    }, [_c('div', {
      staticClass: "nav-item-head-head"
    }, [_vm._v(_vm._s(nav.title))]), _vm._v(" "), _c('div', {
      staticClass: "nav-item-head-foot"
    }, [_vm._v(_vm._s(nav.dTitle))])]), _vm._v(" "), _c('div', {
      staticClass: "nav-item-foot"
    }, [_c('img', {
      attrs: {
        "src": _vm.cdn + nav.path
      }
    })])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b47d1fc0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/taoke/NavRecommend.vue
// module id = 214
// module chunks = 2